// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3722":"4ffca31a","3751":"b16ba153","9080":"7a2f1c24"}[chunkId] + ".chunk.css";
};